import { useForm, Controller } from 'react-hook-form';

import {
  Box,
  Button,
  TextField,
  Typography,
  ThemeProvider,
} from '@material-ui/core';

import { useResetPassword } from 'hooks/authentication.hook';

import { generateTheme } from 'utils/helpers';

import { useStyles } from './ResetPasswordForm.styles';

const ResetPasswordForm = () => {
  const { control, handleSubmit } = useForm();

  const resetPassword = useResetPassword();

  const classes = useStyles();

  const onSubmitHandler = data => {
    resetPassword.mutate(data);
  };
  return (
    <>
      <Typography>
        Ingresa el email con el que inicias sesión; si está registrado en
        nuestro sistema, te enviaremos un enlace para recuperarla.
      </Typography>
      <Box pt={2}>
        <form onSubmit={handleSubmit(onSubmitHandler)}>
          <Controller
            name="email"
            defaultValue=""
            control={control}
            rules={{
              required: 'Este campo es requerido',
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                message: 'Escribe un correo válido',
              },
            }}
            render={({ field: { value, onChange }, fieldState: { error } }) => (
              <ThemeProvider theme={theme => generateTheme(theme, 'light')}>
                <TextField
                  fullWidth
                  type="email"
                  variant="outlined"
                  error={!!error}
                  value={value}
                  onChange={onChange}
                  helperText={
                    error ? error.message : 'Correo para iniciar sesión'
                  }
                />
              </ThemeProvider>
            )}
          />
          <Box pt={2} textAlign="center">
            <Button
              type="submit"
              variant="contained"
              disabled={resetPassword.isLoading}
              className={classes.button}
            >
              Enviar
            </Button>
          </Box>
        </form>
      </Box>
    </>
  );
};

export default ResetPasswordForm;
